/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import classNames from 'classnames';

import styles from './accommodation-features-v2.module.scss';
import { BaseFeature } from '../../../../types/accommodation-features';

type Props = {
  accommodationFeatures: BaseFeature[];
  accommodationFeatureHighlights: string[];
};

export const AccommodationFeaturesV2 = ({
  accommodationFeatures,
  accommodationFeatureHighlights,
}: Props) => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const featuresCount = accommodationFeatures.length;

  return (
    <div>
      <h4>Highlighted features:</h4>
      <ul className={styles.additionalFeatures}>
        {accommodationFeatureHighlights?.map((feature, index) => {
          return (
            <li key={index} className={classNames(styles.accommodationFeaturePill)}>
              <div className={styles.featureTitle}>{feature}</div>
            </li>
          );
        })}
        {accommodationFeatures && (
          <button
            type="button"
            onClick={() => setShowAllFeatures(!showAllFeatures)}
            className={styles.remainingPills}
          >
            {showAllFeatures ? '- hide' : `+ ${featuresCount} more`}
          </button>
        )}
      </ul>
      {showAllFeatures ? (
        <>
          <h4>All features:</h4>
          <ul className={styles.additionalFeatures}>
            {accommodationFeatures.map((feature, index) => (
              <li key={index} className={classNames(styles.accommodationFeaturePill)}>
                <div className={styles.featureTitle}>
                  <span>{feature?.display_name}</span>:{' '}
                  {feature?.specifics?.display_name || feature?.display_name}{' '}
                  <span>{feature?.room === 'N/A' ? '' : ` in the  ${feature?.room}`}</span>
                </div>
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
};
